"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));
/**
 * This component can grow and shrink inside a FlexBox, Row or Column.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/Flexible-class.html
 */


const Flexible = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n"])), ({
  grow = 1
}) => grow, props => props.shrink, props => props.basis);
exports.default = Flexible;